var netNav = {

    config : {
        container : jQuery('#netNav'),
        trigger : jQuery('.netNavTrigger'),
        breakpoint : 1000
    },

    mobile: false,
    open: false,
    openBranch: false,

    init: function (config) {
        // provide for custom configuration via init()
        if (config && typeof(config) == 'object') {
            jQuery.extend(netNav.config, config);
        }

        // create and/or cache some DOM elements we'll want to use throughout the code
        netNav.body = jQuery('body');
        netNav.container = netNav.config.container;
        netNav.list = netNav.container.find('ul.level1 > li.menu-item-has-children');
        netNav.trigger = netNav.config.trigger;
        netNav.breakpoint = netNav.config.breakpoint;
        netNav.anchorLinks = netNav.container.find('a');

        // add level and hasChildren classes to ul and li elements
        netNav.addClasses(netNav.container.children('ul'));

        // add click event for each anchor that has a sub menu
        jQuery.each(netNav.anchorLinks, function() {
            var link = jQuery(this);

            if(link.siblings('ul').length) {

                // a link with an ul as sibling
                link

                // store a reference to the sub sublevel
                .data('sub', link.siblings('ul'))

                // store a reference to the link parent li
                .data('parent', link.parent('li'))

                // bind the click behavior to the link
                .on('click', netNav.toggleSubLevel);

            }
        });

        // add events
        netNav.addEvents();

    },

    /*
    * add level classes to all ul elements
    */

    addClasses: function(ul, level) {
        level = (typeof level !== 'undefined') ? level : 1;

        // add a level data attribute:
        ul.data('level', level);

        // find any child <ul> elements and run this function on them
        if (ul.children('li').children('ul').length) {
            // add hasChildren class to parent li
            ul.children('li').children('ul').parent().addClass('hasChildren').data('level', level);
            netNav.addClasses(ul.children('li').children('ul'), level + 1);
        }
    },

    /*
    * hide all sub menus
    */

    hideAllSubLevels: function() {

        netNav.container.find('ul:not(.level1)').addClass('hidden').removeClass('visible');
        netNav.container.find('.open').removeClass('open');
        netNav.container.find('.active').removeClass('active');

    },

    /*
    * hide only sibling sub menus
    * needed when switching from one main branch to another
    */

    hideSiblingSubLevels: function( element ) {

        element.siblings().find('ul').addClass('hidden').removeClass('visible');
        element.siblings().find('.open').removeClass('open');
        element.siblings().find('.active').removeClass('active');

    },

    /*
    * show the targeted sub menu
    */

    toggleSubLevel : function(e) {
        // capture the anchor item that was clicked on
        var anchor = jQuery(this);

        // get the sub ul which we stored using data()
        var sub = anchor.data('sub');

        // get the parent element (li) which we stored using data
        var parent = anchor.data('parent');
        var level = parent.closest('ul').data('level');

        if ( netNav.mobile || level == 1) {
            e.preventDefault();
        }

        // remove the active marker from all other anchors
        netNav.anchorLinks.not(anchor).parent().removeClass('active');

        // mark the clicked nav item as active
        parent.toggleClass('active');

        // mark the clicked nav item as open
        parent.toggleClass('open');

        // show the sub
        sub.toggleClass('hidden');
        sub.toggleClass('visible');

        if( netNav.mobile == false ) {
            if( level == 1 && netNav.open == false ) {
                /* initial open */
                netNav.show();
                netNav.setOpenBranch(parent.index());
            } else if( level == 1 && netNav.open == true && netNav.openBranch == parent.index() ) {
                /* clicked on the same 1st level li */
                netNav.hide();
            } else if ( level == 1 ) {
                /* changed the branch */
                netNav.setOpenBranch(parent.index());
                netNav.hideSiblingSubLevels(parent);
            }
        }
    },

    activate: function (index) {
        netNav.container.find('ul.level1 > li').eq( index ).find('> a').trigger('click');
    },

    show: function () {
        netNav.body.addClass('nav-is-open');
        netNav.container.addClass('show');
        netNav.trigger.addClass('active');

        netNav.setOpen(true);
    },

    hide: function () {
        netNav.body.removeClass('nav-is-open');
        netNav.container.removeClass('show');
        netNav.trigger.removeClass('active');

        netNav.hideAllSubLevels();

        netNav.setOpen(false);
        netNav.setOpenBranch(false);
    },

    addEvents: function() {
        netNav.eventInitCloseNav();
        netNav.eventNavTrigger();

        netNav.addMediaQueryWatcher("(min-width: " + netNav.config.breakpoint + "px)", matches => {
            if (matches) {
                netNav.container.removeClass('mobile').addClass('desktop');
                netNav.mobile = false;
            } else {
                netNav.container.removeClass('desktop').addClass('mobile');
                netNav.mobile = true;
            }
            if(netNav.open == true ) {
                netNav.hide();
            }
        });
    },

    removeEvents: function() {

    },

    addMediaQueryWatcher: function(mediaQuery, layoutChangedCallback) {
        let mql = window.matchMedia(mediaQuery);

        try {
            mql.addEventListener((e) => { return layoutChangedCallback(e.matches); }); // Chrome & Firefox
        } catch (e1) {
            try {
                mql.addListener((e) => { return layoutChangedCallback(e.matches); }); // Safari
            } catch (e2) {
                console.error(e2);
            }
        }

        layoutChangedCallback(mql.matches);
    },

    setOpen: function(value) {
        netNav.open = value;
    },

    setOpenBranch: function(value) {
        netNav.openBranch = value;
    },

    /*
    * EVENTS
    */

    eventInitCloseNav: function() {
        jQuery('html').on('click', function(event) {
            if (
                jQuery(event.target).closest(netNav.container).length === 0 &&
                jQuery(event.target).closest(netNav.trigger).length === 0)
            {
                netNav.hide();
            }
        });
    },

    eventNavTrigger: function() {
        jQuery(netNav.trigger).on('click', function() {
            netNav.open == true ? netNav.hide() : netNav.show();
        });
    },
};
